import { useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Check } from "lucide-react";

const OrderSuccess = () => {
  const [params] = useSearchParams();
  useEffect(() => { document.title = "Order Confirmed | MyStudio"; }, []);
  return (
    <div className="pt-32 min-h-[60vh] container mx-auto px-4 text-center">
      <div className="w-16 h-16 bg-primary text-primary-foreground mx-auto mb-6 flex items-center justify-center">
        <Check className="w-8 h-8" />
      </div>
      <h1 className="text-3xl md:text-5xl font-display font-extrabold uppercase tracking-widest mb-4">ORDER CONFIRMED</h1>
      <p className="text-muted-foreground font-body mb-8">A confirmation email is on its way. We'll be in touch shortly.</p>
      {params.get("session_id") && (
        <p className="font-mono text-xs text-muted-foreground mb-8">Ref: {params.get("session_id")}</p>
      )}
      <div className="flex gap-3 justify-center">
        <Button asChild variant="outline"><Link to="/shop">Continue shopping</Link></Button>
        <Button asChild><Link to="/">Home</Link></Button>
      </div>
    </div>
  );
};

export default OrderSuccess;